<script lang="ts">
	//UI
	import { Card } from "@hitit/new_ui/src";
	import KoreaRegistration from "./KoreaRegistration.svelte";
	import StoreInfomationViewer from "./StoreInfomationViewer.svelte";
	import ComponentCover from "../common/ComponentCover.svelte";
	import ComponentLoading from "../common/ComponentLoading.svelte";
	//Image
	import EditIcon from "@hitit/hub/src/assets/Icons/Edit.png";
	import SaveIcon from "@hitit/hub/src/assets/Icons/Save.png";
	//Utils
	import { getT } from "@hitit/utils";
	import { t, api } from "@hitit/hub/src/stores";
	// Types
	import type { StoreData, AddressData } from "@hitit/api";
	import { accessControlList, storeLogos } from "../../store";
	// Props
	export let store: StoreData;
	export let editmode = false;
	export let coverStatus = false;
	export let editable = true;
	//Constants
	const additionalInfoKey = [
		"KO_REGISTRATION_LINKED_CASHRECEIPT_MEMBERSHIP",
		"KO_IS_CASH_RECEIPT_AVAILABLE",
		"KO_REGISTRATION_NUMBER",
		"KO_REGISTRATION_FILE_ADDR",
		"KO_OWNER_NAME",
		"KO_REGISTRATION_STORETYPE",
		"KO_REGISTRATION_STORENAME",
		"KO_REGISTRATION_STORECLASS",
		"KO_REGISTRATION_STORE_ADDR",
		"KO_REGISTRATION_CONTACTNAME",
		"KO_REGISTRATION_CONTACTEMAIL",
		"KO_REGISTRATION_CONTACTNUMBER",
		"KO_IS_MOBILE_PAYMENT_AVAILABLE",
	];
	//Variables
	let loading = false;
	let additionalInfoObject: Record<string, string> = {};
	let address: AddressData = {
		lat: 0,
		lng: 0,
		formattedAddressEng: null,
		formattedAddress1: "",
		formattedAddress2: "",
		detailAddress: "", //EditAble
		country: "",
		source: "",
	};
	let storeMainInfo = {
		phonenumber: "",
		phonenumberCountryCode: "",
		type1: "",
		type2: "",
		appLockEnabled: false, //Editable
		storeDescription: "", //Editable
		storename: "", //Editable
		storeStatus: "",
		storeImageUrl: "",
	};
	async function actionHandler() {
		if (!editmode) {
			editmode = true;
			return;
		}

		try {
			loading = true;
			console.log(store);
			const oldTranslationDTO = store.translationDTOs.find(
				(v) => v.lang === "ko" || v.defaultLang
			);

			const oldTranslationDTOIndex = store.translationDTOs.findIndex(
				(v) => oldTranslationDTO === v
			);
			const newAddressDTO = Object.assign({}, store.addressDTO, { ...address });
			const newTranslationDTO = Object.assign({}, oldTranslationDTO || {}, {
				name: storeMainInfo.storename,
				description: storeMainInfo.storeDescription,
				id: "",
				lang: oldTranslationDTO ? oldTranslationDTO.lang : "ko",
				defaultLang: oldTranslationDTO ? oldTranslationDTO.defaultLang : true,
			});
			const newAdditionalInfo = Object.entries(additionalInfoObject)
				.map(([key, value]) => ({ key, value }))
				.filter((v) => v.value !== "");
			if (oldTranslationDTOIndex >= 0) {
				store.translationDTOs[oldTranslationDTOIndex] = newTranslationDTO;
			} else {
				store.translationDTOs.push(newTranslationDTO);
			}
			store.phonenumber = storeMainInfo.phonenumber;
			store.phonenumberCountryCode = storeMainInfo.phonenumberCountryCode;
			store.addressDTO = newAddressDTO;
			store.storeAdditionalInfoDTOList = newAdditionalInfo;
			store.appLockEnabled = storeMainInfo.appLockEnabled;
			await $api.updateStore(store);
			await accessControlList.updateAccessControl();
			storeLogos.refreshStoreLogos();
			editmode = false;
			store = store;
		} catch (e) {
			console.log(e);
			alert($t("sso.error.unknownError"));
		} finally {
			loading = false;
		}
	}

	function updateStoreImage(e: any) {
		console.log("?", e.detail);
	}

	function dataMapping(store: StoreData) {
		// Mapping additional info
		additionalInfoObject = {};
		for (const key of additionalInfoKey) {
			additionalInfoObject[key] = "";
		}

		for (const data of store.storeAdditionalInfoDTOList) {
			const key = data.key;
			additionalInfoObject[key] = data.value;
		}
		// Address
		address = { ...store.addressDTO };
		// MainInfo
		storeMainInfo.appLockEnabled = store.appLockEnabled || false;
		storeMainInfo.phonenumber = store.phonenumber || "";
		storeMainInfo.phonenumberCountryCode = store.phonenumberCountryCode || "82";
		storeMainInfo.type1 =
			(store.storeTypeCodeDTO &&
				getT(store.storeTypeCodeDTO.translationDTOs, "type1", "ko")) ||
			"";

		storeMainInfo.type2 =
			(store.storeTypeCodeDTO &&
				getT(store.storeTypeCodeDTO.translationDTOs, "type2", "ko")) ||
			"";
		storeMainInfo.storename = getT(store.translationDTOs, "name", "ko") || "";
		storeMainInfo.storeDescription =
			getT(store.translationDTOs, "description", "ko") || "";
		storeMainInfo.storeStatus = store.storeApplicationStatus;
	}
	$: dataMapping(store);
</script>

<Card noPadding>
	<div class="container">
		{#if coverStatus}
			<ComponentCover />
		{/if}
		{#if loading}
			<ComponentLoading coverMode />
		{/if}
		{#if editable}
			<div class="action" on:click={actionHandler}>
				<span>{editmode ? $t("global.done") : $t("global.edit")}</span>
				<img
					src={editmode ? SaveIcon : EditIcon}
					alt={editmode ? "save" : "edit"}
				/>
			</div>
		{/if}
		<StoreInfomationViewer
			type1={storeMainInfo.type1}
			type2={storeMainInfo.type2}
			editmode={editmode}
			formattedAddress1={address.formattedAddress1}
			formattedAddress2={address.formattedAddress2}
			bind:storeImageURL={storeMainInfo.storeImageUrl}
			bind:detailAddress={address.detailAddress}
			bind:appLockEnabled={storeMainInfo.appLockEnabled}
			bind:phonenumber={storeMainInfo.phonenumber}
			bind:phonenumberCountryCode={storeMainInfo.phonenumberCountryCode}
			bind:storeDescription={storeMainInfo.storeDescription}
			bind:storename={storeMainInfo.storename}
			on:UPDATE_STORE_IMAGE={updateStoreImage}
			storeStatus={storeMainInfo.storeStatus}
			smartpayAvailable={additionalInfoObject["KO_IS_MOBILE_PAYMENT_AVAILABLE"]}
			cacheReceiptAvailable={additionalInfoObject[
				"KO_IS_CASH_RECEIPT_AVAILABLE"
			]}
		/>
		<div class="seperate-bar" />
		<KoreaRegistration
			editmode={editmode}
			ownername={additionalInfoObject["KO_OWNER_NAME"]}
			bind:registrationNumber={additionalInfoObject["KO_REGISTRATION_NUMBER"]}
			bind:registrationImage={additionalInfoObject["KO_REGISTRATION_FILE_ADDR"]}
			storeType={additionalInfoObject["KO_REGISTRATION_STORETYPE"]}
			storeName={additionalInfoObject["KO_REGISTRATION_STORENAME"]}
			storeClass={additionalInfoObject["KO_REGISTRATION_STORECLASS"]}
			storeAddr={additionalInfoObject["KO_REGISTRATION_STORE_ADDR"]}
			contactName={additionalInfoObject["KO_REGISTRATION_CONTACTNAME"]}
			contactEmail={additionalInfoObject["KO_REGISTRATION_CONTACTEMAIL"]}
			contactPhone={additionalInfoObject["KO_REGISTRATION_CONTACTNUMBER"]}
		/>
	</div>
</Card>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: 34px 10px 20px 10px;
		gap: 20px;
		//
		position: relative;

		.action {
			display: flex;
			gap: 10px;
			align-items: center;
			position: absolute;
			right: 10px;
			top: 10px;
			color: #6d6f76;
			font-weight: 500;

			&:hover {
				cursor: pointer;
			}
			img {
				width: 24px;
				height: 24px;
				object-fit: contain;
			}
		}

		.seperate-bar {
			width: 100%;
			height: 1px;
			background-color: #d3d4da;
		}
	}

	@include DesktopSize {
		.container {
			padding: 30px;
			.action {
				top: 20px;
				right: 20px;
			}
		}
	}
</style>
